import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { IForm } from '@hooks/useForm';
import { ILoading } from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IStepper } from '@hooks/useStepper';
import { Box, makeStyles } from '@material-ui/core';
import { ICliente } from '@model/Cliente';
import { IContratoCliente } from '@model/ContratoCliente';
import ILinha from '@model/Linha';
import { useContratoClienteService } from '@services/ContratoClienteService';
import { useThemeColor } from '@themes/Colors';
import clsx from 'clsx';
import React from 'react';

export type ResumoCommandProps = {
    linhaForm: IForm<Partial<ILinha>>
    clienteForm: IForm<Partial<ICliente>>
    contratoForm: IForm<Partial<IContratoCliente>>
    stepper: IStepper
    loading: ILoading
    onFinished: (contratoCliente: IContratoCliente) => void
}

export function ResumoCommand ({ linhaForm, clienteForm, contratoForm, stepper, loading, onFinished }: ResumoCommandProps) {
    const cls = useStyles();
    const themeColor = useThemeColor();
    const contratoClienteService = useContratoClienteService();
    const message = useMessage();

    const handlePrev = React.useCallback(() => {
        stepper.prev();
    }, [stepper]);

    const handleFinish = React.useCallback(() => {
        if (!loading.isLoading) {
            loading.start();
            
            const request = {
                linha: linhaForm.getValues(),
                cliente: clienteForm.getValues(),
                contrato: contratoForm.getValues(),
            }

            contratoClienteService.registrar(request)
                .then(response => {
                    onFinished(response.data);
                })
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [clienteForm, contratoClienteService, contratoForm, linhaForm, loading, message.showException, onFinished]);

    return (
        <Box className={cls.box}>
            <HorizontalGrid className={clsx(themeColor.component.commandPanel, cls.grid)}>
                <GridItem>
                    <PrimaryButton onClick={handlePrev}>Voltar</PrimaryButton>
                </GridItem>

                <GridItem floatRight>
                    <HorizontalGrid spacing={1} verticalAlign="center">
                        <React.Fragment>
                            <GridItem>
                                <PrimaryButton onClick={handleFinish}>Registrar Contrato</PrimaryButton>
                            </GridItem>
                        </React.Fragment>
                    </HorizontalGrid>
                </GridItem>
            </HorizontalGrid>
        </Box>
    )
}

const useStyles = makeStyles(theme => ({
    box: {
        marginTop: theme.spacing(2)
    },

    grid: {
        padding: `${theme.spacing(1)}px ${theme.spacing(4)}px`
    }
}));